/** Stat cards that ignore the dashboard date range (point-in-time snapshot). */
export const SNAPSHOT_STAT_CARD_IDS = new Set<string>(['open-orders']);

export function isSnapshotStatCard(metricId: string): boolean {
  return SNAPSHOT_STAT_CARD_IDS.has(metricId);
}

export function getSnapshotStatCardFootnote(metricId: string): string | null {
  switch (metricId) {
    case 'open-orders':
      return 'CyD pendientes de cierre en Boris · sin filtro de período';
    default:
      return null;
  }
}
